import "react";
import { DataDisplay } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/count/CountOccurrenceDisplay.tsx
function CountOccurrenceDisplay({ occurrence }) {
	return /* @__PURE__ */ jsxs(DataDisplay, {
		dividers: "space",
		space: "xs",
		children: [/* @__PURE__ */ jsx(DataDisplay.Item, {
			label: "Occurrence",
			children: "Count"
		}), /* @__PURE__ */ jsxs(DataDisplay.Item, {
			label: "Minimum",
			children: [
				"At least ",
				occurrence.minCount,
				" ",
				occurrence.minCount === 1 ? "time" : "times"
			]
		})]
	});
}
//#endregion
export { CountOccurrenceDisplay };

//# sourceMappingURL=CountOccurrenceDisplay.js.map